import React from 'react';

const GroceryShimmer = () => {
  return (
    <div className="body xl:max-w-[80%] mx-auto min-h-screen px-4 sm:px-6 md:px-0 animate-pulse">
      <div className="h-12 w-48 bg-gray-200 rounded mb-4"></div>
      <div className="flex gap-4 overflow-x-auto py-4">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="flex-shrink-0 w-36 h-48 bg-gray-200 rounded-xl"></div>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 my-8">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <div key={i} className="h-64 bg-gray-200 rounded-xl"></div>
        ))}
      </div>
    </div>
  );
};

export default GroceryShimmer;